import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { PostLoginFboSchema, type PostLoginFbo } from "@/lib/validation";
import type { UseMetricOptions } from "./useTraffic";

export function usePostLoginFbo(
  range: TimeRange,
  options: UseMetricOptions = {},
) {
  return useQuery<PostLoginFbo>({
    queryKey: qk.metrics.postLoginFbo(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/post-login-fbo?${toSearchParams(range).toString()}`,
        { signal },
      );
      return PostLoginFboSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
